/**
 * Opens a WhatsApp conversation, routing to the native app on mobile
 * and WhatsApp Web on desktop.
 *
 * @param {string} phone   - Phone number (digits only recommended, e.g. "2348012345678")
 * @param {string} message - Optional pre-filled message text
 */
export const openWhatsApp = (phone, message = "") => {
  const num = phone.replace(/\D/g, "");
  const text = encodeURIComponent(message);
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const url = isMobile
    ? `whatsapp://send?phone=${num}${text ? `&text=${text}` : ""}`
    : `https://web.whatsapp.com/send?phone=${num}${text ? `&text=${text}` : ""}`;
  window.open(url, "_blank", "noopener,noreferrer");
};

/**
 * Builds a pre-filled booking inquiry message for WhatsApp redirection.
 *
 * @param {object} opts
 * @param {string} opts.roomType
 * @param {string} opts.checkIn
 * @param {string} opts.checkOut
 * @returns {string}
 */
export const buildBookingMessage = ({ roomType = "", checkIn = "", checkOut = "" } = {}) => {
  const parts = ["Hello, I would like to book a stay at Aurelia Apartments."];
  if (roomType) parts.push(`Room type: ${roomType}`);
  if (checkIn)  parts.push(`Check-in: ${checkIn}`);
  if (checkOut) parts.push(`Check-out: ${checkOut}`);
  return parts.join("\n");
};
